import { render, staticRenderFns } from "./NewsSearchItem.vue?vue&type=template&id=0ec631c4"
import script from "./NewsSearchItem.vue?vue&type=script&lang=js"
export * from "./NewsSearchItem.vue?vue&type=script&lang=js"
import style0 from "./NewsSearchItem.vue?vue&type=style&index=0&id=0ec631c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports